import React from 'react';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { Input } from '../../../components/common-inputs';
import CommonModal from '../../../components/common-modal/CommonModal';
import WithError from '../../../components/with-error/WithError';
import validate from '../../../utils/validate';
import { supportYopValidation } from './validation';
import CommonButton, { BUTTON_STYLES } from '../../../components/common-button/CommonButton';
import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';
import CommonTextarea from '../../../components/common-textarea/CommonTextarea';

import scss from './SupportModal.module.scss';

function SupportModal({ isOpen, onClose, onClickForHelp }) {
  const { t } = useTranslation('scout');

  const initialSupportFormValues = {
    email: '',
    question: '',
  };

  const handleSendSupportRequest = async (values) => {
    await onClickForHelp(values);
    onClose();
  };

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} wrapperClassName={scss.supportModal}>
      <Form
        initialValues={initialSupportFormValues}
        onSubmit={handleSendSupportRequest}
        subscription={{ submitting: true, pristine: true }}
        validate={(values) => validate(values, supportYopValidation())}
        render={({ handleSubmit, submitting }) => (
          <form className={scss.wrapper} onSubmit={handleSubmit}>
            <h3 className={scss.title}>{t('needHelp?')}</h3>

            <div className={scss.fields}>
              <label className={scss.label}>
                {t('pleaseEnterYourEmail')}

                <Field name='email'>
                  {({ meta, input }) => (
                    <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)}>
                      <Input
                        size='sm'
                        placeholder={t('email')}
                        formProps={input}
                        isError={meta.touched && meta.error}
                        disabled={submitting}
                        LeftIcon={<Icon icon={ICONS.Email} disableCommonStyles />}
                      />
                    </WithError>
                  )}
                </Field>
              </label>

              <Field name='question'>
                {({ meta, input }) => (
                  <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)}>
                    <CommonTextarea
                      placeholder={t('message')}
                      isError={meta.touched && meta.error}
                      disabled={submitting}
                      rows='3'
                      enableVoiceInput
                      {...input}
                    />
                  </WithError>
                )}
              </Field>
            </div>

            <div className={scss.actions}>
              <CommonButton styleColor={BUTTON_STYLES.SECONDARY} maxWidth={120} onClick={onClose} disabled={submitting}>
                {t('cancel')}
              </CommonButton>
              <CommonButton styleColor={BUTTON_STYLES.PRIMARY} maxWidth={120} type='submit' isLoading={submitting}>
                {t('send')}
              </CommonButton>
            </div>
          </form>
        )}
      />
    </CommonModal>
  );
}

export default SupportModal;
